<!-- エラー画面 デフォルト構成 -->
<template>
  <section class="crpg-o-error-default">
    <ComponentsAtomsError />
  </section>
</template>

<script>
import ComponentsAtomsError from "@/components/atoms/error/Error.vue";

export default {
  name: "OrganismsErrorDefault",
  components: {
    ComponentsAtomsError,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/error/default.scss";
</style>
